import axios from 'axios';

/**
 * @param {import('./config').DocumentTemplateType} documentType
 * @param {import('./config').DocumentDefinition} documentTemplate
 * @returns {Promise<ArrayBuffer>} PDF file as ArrayBuffer
 */
export const getPreview = async (documentType, documentTemplate) => {
  const response = await axios.post(`/templates/${documentType}/${documentType}/preview`, documentTemplate, {
    responseType: 'arraybuffer',
  });
  return response.data;
};

/**
 * @param {import('./config').DocumentTemplateType} documentType
 * @returns {Promise<import('./config').DocumentDefinition>}
 */
export const getSharedTemplate = async (documentType) => {
  const response = await axios.get(`/templates/shared/${documentType}/${documentType}`);
  return response.data;
};

/**
 * @param {import('./config').DocumentTemplateType} documentType
 * @returns {Promise<import('./config').DocumentDefinition>}
 */
export const getTemplate = async (documentType) => {
  const response = await axios.get(`/templates/${documentType}/${documentType}`);
  return response.data;
};

/**
 * @param {import('./config').DocumentTemplateType} documentType
 * @param {import('./config').DocumentDefinition} documentTemplate
 */
export const addOrUpdateTemplate = async (documentType, documentTemplate) => {
  await axios.post(`/templates/${documentType}/${documentType}`, documentTemplate);
};
